<template>
  <div ref="videoContainer">
    <video id="video" ref="videoPlayer" :poster="posterUrl" style="width: 100%;"></video>
  </div>
</template>

<script>
export default {
  props: {
    manifestUrl: {
      type: String,
      required: true
    },
    posterUrl: {
      type: String,
      required: false,
      default: ""
    }
  },
  mounted() {
    const shaka = require("shaka-player/dist/shaka-player.ui.js");
    const player = new shaka.Player(this.$refs.videoPlayer);
    const ui = new shaka.ui.Overlay(player, this.$refs.videoContainer, this.$refs.videoPlayer);
    // ui.getControls().setEnabledNativeControls(false);
    ui.getControls();

    // console.log(Object.keys(shaka.ui));

    const config = {
      addSeekBar: true,
      // addBigPlayButton: true,
      // controlPanelElements: ["overflow_menu"],
      // overflowMenuButtons: ['cast'],
    };
    ui.configure(config);

    // player.configure({
    // drm: {
    //   servers: { 'com.widevine.alpha': this.licenseServer }
    // }
    // });

    player
      .load(this.manifestUrl)
      .then(() => {
        this.$refs.videoPlayer.play();
      })
      .catch(this.onError); // onError is executed if the asynchronous load fails.
  },
  methods: {
    onError(error) {
      console.error("Error code", error.code, "object", error);
    }
  }
};
</script>

<style>
@import '~shaka-player/dist/controls.css';
</style>
